import { render, staticRenderFns } from "./SaMemoryTooltip.vue?vue&type=template&id=122412df&scoped=true"
import script from "./SaMemoryTooltip.vue?vue&type=script&lang=js"
export * from "./SaMemoryTooltip.vue?vue&type=script&lang=js"
import style0 from "./SaMemoryTooltip.vue?vue&type=style&index=0&id=122412df&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122412df",
  null
  
)

export default component.exports